import AuthServices from './authActions';
import othersActions from './othersActions';
import userActions from './userServlet';
import componentActions from './componentActions';
import guidelineActions from './guidelineActions';

export default {
  ...AuthServices,
  ...othersActions,
  ...userActions,
  ...componentActions,
  ...guidelineActions,
};
